var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon36CalendarMonth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 7v19.7c0 1-.8 1.9-1.9 1.9H6.8c-1 0-1.9-.8-1.9-1.9V7c0-1 .8-1.9 1.9-1.9h19.7c1 .1 1.8.9 1.8 1.9zm-1.5 5.5h-4v3.8h4v-3.8zm-5.5 0h-3.9v3.8h3.9v-3.8zm-5.4 0H12v3.8h3.9v-3.8zm-5.5 0h-4v3.8h4v-3.8zm-4 9.2h4v-3.8h-4v3.8zm5.5 0h3.9v-3.8h-3.9v3.8zm0 1.5V27h3.9v-3.8h-3.9zm5.5 3.9h3.9v-3.8h-3.9v3.8zm3.9-5.4v-3.8h-3.9v3.8h3.9zm1.6 0h4v-3.8h-4v3.8zM6.4 7v4h20.4V7c0-.2-.2-.4-.4-.4H6.8c-.2.1-.4.2-.4.4zm.4 20.1h3.6v-3.8h-4v3.5c0 .1.2.3.4.3zm20-.4v-3.5h-4V27h3.6c.3.1.4-.1.4-.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon36CalendarMonth);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_36_CalendarMonth.3fbdd336.svg";
export { ForwardRef as ReactComponent };